// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"6e731400","455":"ed2b1a0d","488":"3c5d99df","977":"01cd3078"}[chunkId] + ".chunk.js";
};